// Janela da aba "Próximos N dias" de Despesas Mensais e Receitas (o backend
// usa o mesmo padrão: `days_ahead=7`).
export const UPCOMING_DAYS = 7;
